import { DefaultLayout, PageContentWrapper } from "Components";
import DashboardBG from "svg/DashboardHeaderBG";
import styled from "styled-components";
import { TabContent, Tabs } from "Components/Tabs";
import SetFan from "./SetFan";
import SetLive from "./SetLive";
import { GlobalStyles } from "styled";
import { useParams } from "react-router-dom";
import { ReactComponent as ClipboardIcon } from "assets/svg/clipboard.svg";
import FanProfile from "./FanProfile";
import { ReactComponent as UsersIcon } from "assets/svg/users.svg";
import { useCustomAppContext } from "contexts/CustomAppContext";
import { ReactComponent as ClipboardFillIcon } from "assets/svg/clipboard-fill.svg";
import { SetBioReporting } from "./SetBio";
import { SvgDashboard } from "melodies-source/Svgs/Dashboard";
import { ReactComponent as SvgMicrophone } from "assets/svg/microphone.svg";
import { bucketImageSource } from "assets/bucketImages";

export const Reporting = () => {
  const { artistId } = useParams<{ artistId: string }>();
  const { customApp } = useCustomAppContext();
  const path = window.location.pathname.split("/")?.pop();

  const tabs = [
    ...(customApp
      ? []
      : [
          {
            param: "fan-profile",
            label: "Fan Profile",
            content: <FanProfile />,
            icon: <UsersIcon />,
            hasHorizontalPadding: false,
            header: bucketImageSource.setToolsHeader,
          },
        ]),
    {
      param: "set-live",
      label: `${customApp?.company.name || "SET"}.Live`,
      content: <SetLive />,
      header: bucketImageSource.setLiveHeader,
      icon: customApp ? (
        <ClipboardFillIcon width={24} height={24} />
      ) : (
        <SvgMicrophone width={26} height={26} />
      ),
    },
    ...(customApp
      ? []
      : [
          {
            param: "set-fan",
            label: `${customApp?.company.name || "SET"}.Fan`,
            content: <SetFan />,
            icon: <ClipboardIcon width={24} height={24} />,
            header: bucketImageSource.setFanHeader,
          },
        ]),
    {
      param: "set-bio",
      label: `${customApp?.company.name || "SET"}.Bio`,
      content: <SetBioReporting />,
      icon: <SvgDashboard width={26} height={26} />,
      header: bucketImageSource.setBioHeader,
    },
  ];

  const activeTab = tabs?.find(({ param }) => param === path);

  return (
    <DefaultLayout>
      <GlobalStyles grayBG />
      {activeTab?.header ? (
        <CategoryHeaderImage src={activeTab.header} />
      ) : (
        <DashboardBG />
      )}
      <PageContentWrapper title="Reporting">
        <StyledTabs tabs={tabs} basePath={`/${artistId}/reporting`} />
      </PageContentWrapper>
    </DefaultLayout>
  );
};

export const CategoryHeaderImage = styled.div<{ src?: string }>`
  width: 100%;
  height: 246px;
  position: absolute;
  background-position: center bottom;
  background-size: cover;
  background-image: ${(p) => `url(${p.src})`};

  ${({ theme }) => theme.mediaQueries.mobile} {
    height: 142px;
  }
`;

const StyledTabs = styled(Tabs)`
  ${TabContent} {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
`;
